/**
 * Determine the effective ISO status
 */

import type { IsoStatus } from '../stores/types/media';

// Maximum allowable time window for iso_status to be determined before resolving to failure
export const ISO_FAILURE_FALLBACK_MS = 12 * 60 * 60 * 1000; // 12 hours 

export interface ResolveIsoStatusArgs {
    isoStatus?: IsoStatus;
    /** existing count-based readiness (feeds present and complete) */
    isoDownloadReady: boolean;
    /** whether any ISO feed rows are currently available to show */
    hasFeeds: boolean;
    /** recording creation time in ms (for the backend-absent fallback) */
    createdDate?: number;
    now?: number;
    fallbackMs?: number;
}

export function resolveIsoStatus({
    isoStatus,
    isoDownloadReady,
    hasFeeds,
    createdDate = 0,
    now = Date.now(),
    fallbackMs = ISO_FAILURE_FALLBACK_MS,
}: ResolveIsoStatusArgs): IsoStatus {
    // Backend status is authoritative when present.
    if (isoStatus) {
        return isoStatus;
    }

    // Legacy fallback: no backend iso_status (e.g. FE deployed ahead of the API).
    // Infer from the old count-based readiness, and don't spin forever — if
    // nothing has arrived after the window, treat it as failed.
    if (isoDownloadReady) {
        return 'complete';
    }
    if (!hasFeeds && now - createdDate > fallbackMs) {
        return 'failed';
    }
    return 'processing';
}
